import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();

  const quickLinks = [
  { label: t('nav_home'), path: '/' },
  { label: t('nav_hurghada'), path: '/hurghada-tours' },
  { label: t('nav_marsa_alam'), path: '/marsa-alam-tours' },
  { label: t('nav_transfers'), path: '/transfers' },
  { label: t('nav_contact'), path: '/contact' },
];

  const legalLinks = [
  { label: t('footer_privacy'), path: '/' },
  { label: t('footer_terms'), path: '/' },
  { label: t('footer_imprint'), path: '/' },
];

  return (
    <footer className="bg-primary-900 text-background-200">
      {/* Main Footer */}
      <div className="w-full px-4 md:px-6 lg:px-12 xl:px-20 py-10 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          {/* Company Info */}
          <div className="sm:col-span-2 lg:col-span-1">
            <button onClick={() => navigate('/')} className="block cursor-pointer mb-4">
              <img
src="/images/yallabina-logo-white-trim.png"
  alt="Yallabina Tours Logo"
  className="h-28 w-auto object-contain"
/>
            </button>
            <p className="text-sm text-background-400 leading-relaxed mb-5">
              {t('footer_company_desc')}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">{t('footer_quick_links')}</h4>
            <ul className="space-y-2.5">
              {quickLinks.map((link) => (
                <li key={link.path}>
                  <button onClick={() => navigate(link.path)} className="text-sm text-background-400 hover:text-accent-400 transition-colors cursor-pointer whitespace-nowrap">
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4"> {t('footer_contact_info')}</h4>
            <ul className="space-y-3 text-sm text-background-400">
              <li>
                <a href="tel:+201000932585" className="flex items-start gap-2 hover:text-accent-400 transition-colors cursor-pointer group">
                  <i className="ri-phone-line text-accent-400 mt-0.5 flex-shrink-0" />
                  <span>+20 100 093 2585</span>
                </a>
              </li>
              <li>
                <a href="https://wa.me/201000932585" target="_blank" rel="noopener noreferrer" className="flex items-start gap-2 hover:text-accent-400 transition-colors cursor-pointer group">
                  <i className="ri-whatsapp-line text-accent-400 mt-0.5 flex-shrink-0" />
                  <span>+20 100 093 2585</span>
                </a>
              </li>
              <li>
                <a href="mailto:info@yallabinatours.com" className="flex items-start gap-2 hover:text-accent-400 transition-colors cursor-pointer group">
                  <i className="ri-mail-line text-accent-400 mt-0.5 flex-shrink-0" />
                  <span>info@yallabinatours.com</span>
                </a>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line text-accent-400 mt-0.5 flex-shrink-0" />
                <span>{i18n.language === 'de' ? 'Hurghada, Ägypten' : 'Hurghada, Egypt'}</span>
              </li>
            </ul>
          </div>

          {/* Follow Us */}
          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">  {t('footer_follow_us')}</h4>
            <ul className="space-y-2.5 mb-5">
              <li>
                <a href="https://wa.me/201000932585" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2.5 text-sm text-background-400 hover:text-accent-400 transition-colors cursor-pointer group">
                  <span className="w-7 h-7 bg-primary-800 rounded-sm flex items-center justify-center text-accent-400 group-hover:bg-accent-500 group-hover:text-primary-950 transition-colors flex-shrink-0">
                    <i className="ri-whatsapp-line text-sm" />
                  </span>
                  WhatsApp
                </a>
              </li>
              <li>
                <a href="https://www.facebook.com/Yallabinatours" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2.5 text-sm text-background-400 hover:text-accent-400 transition-colors cursor-pointer group">
                  <span className="w-7 h-7 bg-primary-800 rounded-sm flex items-center justify-center text-background-300 group-hover:bg-accent-500 group-hover:text-primary-950 transition-colors flex-shrink-0">
                    <i className="ri-facebook-line text-sm" />
                  </span>
                  Facebook
                </a>
              </li>
              <li>
                <a href="mailto:info@yallabinatours.com" className="flex items-center gap-2.5 text-sm text-background-400 hover:text-accent-400 transition-colors cursor-pointer group">
                  <span className="w-7 h-7 bg-primary-800 rounded-sm flex items-center justify-center text-background-300 group-hover:bg-accent-500 group-hover:text-primary-950 transition-colors flex-shrink-0">
                    <i className="ri-mail-line text-sm" />
                  </span>
                  info@yallabinatours.com
                </a>
              </li>
            </ul>
            <a
              href="https://wa.me/201000932585"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-4 py-2.5 bg-accent-500 text-primary-950 text-sm font-semibold rounded-sm hover:bg-accent-400 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-whatsapp-line" />
              {t('footer_whatsapp_booking')}
            </a>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-primary-800">
        <div className="w-full px-4 md:px-6 lg:px-12 xl:px-20 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            {t('footer_copyright')}
          </p>
          <div className="flex items-center gap-5">
            {legalLinks.map((link) => (
              <button key={link.label} onClick={() => navigate(link.path)} className="text-xs text-background-500 hover:text-accent-400 transition-colors cursor-pointer whitespace-nowrap">
                {link.label}
              </button>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}